<template lang="pug">
.d-flex.align-center
  template(v-if="text")
    .text-xs.basic600--text {{ text }}
    .ml-2.mr-4(style="width: 65px")
      v-select.text-xs.page-size(v-model="pageSize" outlined dense :attach="attach" :items="pageSizes" hide-selected hide-details :menu-props="{ top: menuTop }")
        template(v-slot:append)
          eva-icon(name="chevron-down-outline" width="20" height="20" style="margin-top: 2px" :fill="$colors.basic700")
    v-spacer
  div
    v-btn.rounded-l(:class="{ primary500: page !== 1, primary300: page === 1 }" tile icon height="32" width="32" @click="page--" :disabled="page === 1")
      eva-icon(style="padding-top: 4px; padding-right: 2px;" name="arrow-ios-back-outline" height="17" :fill="$colors.basic100")
  .pl-3
    div(:style="`width: ${boxWidth}px`")
      v-select.text-xs.page-current(v-model="page" outlined dense :attach="attach" :items="pages" hide-details append-icon="" :menu-props="{ top: menuTop }")
        template(v-slot:selection="{ item }")
          .d-flex.justify-center(style="width: 100%;")
            .text-center {{ item }} / {{ totalPages }}
  .pl-3
    v-btn.rounded-r(:class="{ primary500: page !== totalPages, primary300: page === totalPages }" tile icon height="32" width="32" @click="page++" :disabled="page === totalPages")
      eva-icon(style="padding-top: 4px; padding-right: 2px;" name="arrow-ios-forward-outline" height="17" :fill="$colors.basic100")
</template>

<script>
export default {
  name: 'YcPaginationCustom',
  props: ['value', 'parentPageSize', 'count', 'text', 'attach', 'menuTop'],
  data: (vm) => ({
    page: vm.value || 36,
    pageSizes: [20, 40, 80, 100, 200]
  }),
  computed: {
    totalPages () {
      return Math.ceil(this.count/this.pageSize) || 1
    },
    pageSize: {
      get() {
        return this.parentPageSize
      },
      set(newValue) {
        this.$emit('update:parentPageSize', newValue)
      }
    },
    pages () {
      let data = []
      for (let i = 1; i <= this.totalPages; i++) {
        data.push(i)
      }
      return data
    },
    boxWidth () {
      let width = 65
      if (this.totalPages && this.totalPages.toString() && this.totalPages.toString().length > 2) {
        width += (this.totalPages.toString().length - 2) * 15
      }
      return width
    }
  },
  watch: {
    value (val) {
      this.page = val
    },
    page (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
  margin-top: 4px;
  height: 38px;
}
::v-deep .page-size > .v-input__control > .v-input__slot {
  padding: 0 2px 0 8px !important;
}
::v-deep .page-current > .v-input__control > .v-input__slot {
  padding: 0 8px 0 8px !important;
}
</style>